import { useState } from 'react';

import type { LibraryCollection, LibraryItem, MediaPreview, MediaRef } from '../types';

import { LibraryActions } from './LibraryActions';
import { LoadingSpinner } from './LoadingSpinner';

import styles from './MediaCard.module.css';

interface MediaCardProps {
  item: MediaPreview;
  library: LibraryItem[];
  updateCollection: (ref: MediaRef, target: LibraryCollection) => void;
}

export function MediaCard({
  item,
  library,
  updateCollection
}: MediaCardProps) {
  const currentCollection = library.find(
    (m) => m.id === item.id && m.media_type === item.media_type
  )?.collection;

  const year = item.displayDate ? item.displayDate.split('-')[0] : 'N/A';

  const [imgLoaded, setImgLoaded] = useState(false);

  const poster = item.poster_path
    ? `https://image.tmdb.org/t/p/w500${item.poster_path}`
    : `/assets/images/placeholders/media.svg`;

  return (
    <div className={styles.card}>
      <div className={styles.posterWrapper}>
        {!imgLoaded && (
          <LoadingSpinner />
        )}
        <img
          src={poster}
          alt={item.displayTitle}
          className={`${styles.posterImage} ${imgLoaded ? styles.loaded : styles.loading}`}
          loading="lazy"
          onLoad={() => setImgLoaded(true)}
        />
        <LibraryActions
          itemId={item.id}
          mediaType={item.media_type}
          currentCollection={currentCollection}
          updateCollection={updateCollection}
        />
        <div className={styles.ratingBadge}>
          <span>★</span> {item.vote_average?.toFixed(1)}
        </div>
      </div>
      <div className={styles.cardContent}>
        <span className={styles.cardYear}>{year}</span>
        <h3 className={styles.cardTitle} title={item.displayTitle}>{item.displayTitle}</h3>
      </div>
    </div>
  );
}